import { createSlice } from "@reduxjs/toolkit";
import { TEMPLATE_LAYOUT } from "../../constants/dashboard";

const initialState = {
  templates: [],
  totalTemplatesCount: 0,
  userTemplates: [],
  totalUserTemplatesCount: 0,
  totalUserVideoCount: 0,
  template: {},
  verticalVidboardTemplates: [],
  horizontalVidboardTemplates: [],
  hasMoreVerticalVidboardTemplates: false,
  hasMoreHorizontalVidboardTemplates: false,
  verticalTemplates: [],
  horizontalTemplates: [],
  hasMoreVerticalTemplates: false,
  hasMoreHorizontalTemplates: false,
  collections: [],
  currentCollection: 0,
  featureTemplateLoading: false,
  userTemplateLoading: false,
  videoTemplate: [],
  verticalVideoTemplates: [],
  horizontalVideoTemplates: [],
  hasMoreVerticalVideoTemplates: false,
  hasMoreHorizontalVideoTemplates: false,
  videoTemplateLoading: false,
  notificationData: [],
  hasMoreVideoTemplate: false,
  hasMoreUserTemplate: false,
  hasMoreTemplate: false,
  activeLayout: TEMPLATE_LAYOUT.HORIZONTAL,
};

const featuredTemplatesSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {
    setFeaturedTemplates: (state, action) => {
      state.templates = action.payload;
    },
    setUserTemplates: (state, action) => {
      state.userTemplates = action.payload;
    },
    setFeaturedTemplate: (state, action) => {
      state.template = action.payload;
    },
    setVideoTemplate: (state, action) => {
      state.videoTemplate = action.payload;
    },
    setCurrentCollection: (state, action) => {
      state.currentCollection = action.payload;
    },
    setCollection: (state, action) => {
      state.collections = action.payload;
    },
    setTemplateTotalCount: (state, action) => {
      state.totalTemplatesCount = action.payload || 0;
    },
    setUserTemplateTotalCount: (state, action) => {
      state.totalUserTemplatesCount = action.payload || 0;
    },
    setUserVideoTotalCount: (state, action) => {
      state.totalUserVideoCount = action.payload || 0;
    },
    setTemplateLoading: (state, action) => {
      state.featureTemplateLoading =
        action.payload ?? !state.featureTemplateLoading;
    },
    setUserTemplateLoading: (state, action) => {
      state.userTemplateLoading = action.payload ?? !state.userTemplateLoading;
    },
    setVideoTemplateLoading: (state, action) => {
      state.videoTemplateLoading =
        action.payload ?? !state.videoTemplateLoading;
    },
    setNotificationData: (state, action) => {
      state.notificationData = action.payload;
    },
    setHasMoreVideoTemplate: (state, action) => {
      state.hasMoreVideoTemplate = action.payload;
    },
    setHasMoreUserTemplate: (state, action) => {
      state.hasMoreUserTemplate = action.payload;
    },
    setHasMoreTemplate: (state, action) => {
      state.hasMoreTemplate = action.payload;
    },
    setHasMoreVerticalTemplates: (state, action) => {
      state.hasMoreVerticalTemplates = action.payload;
    },
    setHasMoreHorizontalTemplates: (state, action) => {
      state.hasMoreHorizontalTemplates = action.payload;
    },
    setVerticalTemplates: (state, action) => {
      state.verticalTemplates = action.payload;
    },
    setHorizontalTemplates: (state, action) => {
      state.horizontalTemplates = action.payload;
    },
    setHasMoreVerticalVideoTemplates: (state, action) => {
      state.hasMoreVerticalVideoTemplates = action.payload;
    },
    setHasMoreHorizontalVideoTemplates: (state, action) => {
      state.hasMoreHorizontalVideoTemplates = action.payload;
    },
    setVerticalVideoTemplates: (state, action) => {
      state.verticalVideoTemplates = action.payload;
    },
    setHorizontalVideoTemplates: (state, action) => {
      state.horizontalVideoTemplates = action.payload;
    },
    setActiveLayout: (state, action) => {
      state.activeLayout = action.payload || TEMPLATE_LAYOUT[0].value;
    },
    setHasMoreVerticalVidboardTemplates: (state, action) => {
      state.hasMoreVerticalVidboardTemplates = action.payload;
    },
    setHasMoreHorizontalVidboardTemplates: (state, action) => {
      state.hasMoreHorizontalVidboardTemplates = action.payload;
    },
    setVerticalVidboardTemplates: (state, action) => {
      state.verticalVidboardTemplates = action.payload;
    },
    setHorizontalVidboardTemplates: (state, action) => {
      state.horizontalVidboardTemplates = action.payload;
    },
    updateVideoTitle: (state, action) => {
      const videos =
        state.activeLayout === TEMPLATE_LAYOUT.HORIZONTAL
          ? state.horizontalVideoTemplates
          : state.verticalVideoTemplates;

      const index = videos.findIndex(
        (template) => template.id === action.payload.id
      );
      if (index !== -1) {
        videos[index].name = action.payload.name;
        videos[index].projectName = action.payload.name;
      }
    },
    updateUserTitle: (state, action) => {
      const templates =
        state.activeLayout === TEMPLATE_LAYOUT.HORIZONTAL
          ? state.horizontalTemplates
          : state.verticalTemplates;

      const index = templates.findIndex(
        (template) => template.id === action.payload.id
      );
      if (index !== -1) {
        templates[index].name = action.payload.name;
      }
    },
  },
});

export const {
  setFeaturedTemplates,
  setFeaturedTemplate,
  setUserTemplates,
  setCollection,
  setCurrentCollection,
  setTemplateTotalCount,
  setUserTemplateTotalCount,
  setTemplateLoading,
  setUserTemplateLoading,
  setVideoTemplate,
  setUserVideoTotalCount,
  setVideoTemplateLoading,
  setNotificationData,
  setHasMoreVideoTemplate,
  setHasMoreTemplate,
  setHasMoreUserTemplate,
  setHasMoreHorizontalTemplates,
  setHasMoreVerticalTemplates,
  setHorizontalTemplates,
  setVerticalTemplates,
  setHasMoreHorizontalVideoTemplates,
  setHasMoreVerticalVideoTemplates,
  setHorizontalVideoTemplates,
  setVerticalVideoTemplates,
  setHasMoreVerticalVidboardTemplates,
  setHasMoreHorizontalVidboardTemplates,
  setVerticalVidboardTemplates,
  setHorizontalVidboardTemplates,
  setActiveLayout,
  updateUserTitle,
  updateVideoTitle,
} = featuredTemplatesSlice.actions;
export default featuredTemplatesSlice.reducer;
